import type { FinancialTableColumn } from "@/features/financialShared";

export const CHARGES_PROPERTY_COLUMNS: FinancialTableColumn[] = [
	{ id: "name", label: "Property Name" },
	{ id: "totalUnits", label: "Total Units" },
	{ id: "latestServicePeriod", label: "Latest Service Period" },
	{ id: "chargesCategory", label: "Charges Category" },
	{ id: "status", label: "Status" },
	{ id: "lastUpdatedDate", label: "Last Updated Date" },
	{ id: "approver", label: "Approver" },
];

export const CHARGES_SERVICE_PERIOD_COLUMNS: FinancialTableColumn[] = [
	{ id: "period", label: "Service Period" },
	{ id: "dueDate", label: "Due Date" },
	{ id: "paidUnits", label: "Paid Units" },
	{ id: "status", label: "Status" },
	{ id: "createdDate", label: "Created Date" },
	{ id: "lastUpdated", label: "Last Updated" },
	{ id: "approver", label: "Approver" },
	{ id: "action", label: "Action", align: "right" },
];

export const CHARGES_UNIT_COLUMNS: FinancialTableColumn[] = [
	{ id: "unit", label: "Unit" },
	{ id: "owner", label: "Owner" },
	{ id: "invoiceNumber", label: "Invoice Number" },
	{ id: "amount", label: "Amount" },
	{ id: "tax", label: "VAT / Tax" },
	{ id: "total", label: "Total" },
	{ id: "partialPayment", label: "Partial Payment" },
	{ id: "remaining", label: "Remaining" },
	{ id: "paymentMethod", label: "Payment Method" },
	{ id: "status", label: "Status" },
	{ id: "action", label: "Action", align: "right" },
];

export const CHARGES_BREAKDOWN_COLUMNS: FinancialTableColumn[] = [
	{ id: "category", label: "Category" },
	{ id: "description", label: "Description" },
	{ id: "amount", label: "Amount" },
	{ id: "tax", label: "Tax" },
	{ id: "total", label: "Total (Inc. Tax)" },
];

export const CHARGES_PROPERTY_TABLE_MIN_WIDTH = "min-w-[1000px]";
export const CHARGES_PERIOD_TABLE_MIN_WIDTH = "min-w-[1000px]";
export const CHARGES_UNIT_TABLE_MIN_WIDTH = "min-w-[1280px]";
export const CHARGES_BREAKDOWN_TABLE_MIN_WIDTH = "min-w-[700px]";
export const CHARGES_PAGE_SIZE = 10;
export const CHARGES_PERIODS_LOOKUP_PAGE_SIZE = 100;

export const CHARGES_LISTING_STATUS_FILTER = [
	{ value: "ALL", label: "All Statuses" },
	{ value: "DRAFT", label: "Draft" },
	{ value: "PUBLISHED", label: "Published" },
	{ value: "COMPLETED", label: "Completed" },
] as const;

export const CHARGES_LISTING_SORT_OPTIONS = [
	{ value: "NAME", label: "Property Name" },
	{ value: "TOTAL_UNITS", label: "Total Units" },
	{ value: "LATEST_SERVICE_PERIOD", label: "Latest Service Period" },
	{ value: "LAST_UPDATED", label: "Last Updated" },
] as const;

export const CHARGES_PERIOD_FILE_MAX_MB = 20;
export const CHARGES_PERIOD_FILE_ACCEPT = ".xlsx,.xls";

export const CHARGES_UNIT_STATUS_FILTER = [
	{ value: "ALL", label: "All Statuses" },
	{ value: "SETTLED", label: "Settled" },
	{ value: "PARTIALLY_PAID", label: "Partially Paid" },
	{ value: "OUTSTANDING", label: "Outstanding" },
	{ value: "PAST_DUE", label: "Past Due" },
] as const;

export const CHARGES_UNIT_PAYMENT_METHOD_FILTER = [
	{ value: "ALL", label: "All Methods" },
	{ value: "APP", label: "App" },
	{ value: "CASH", label: "Cash" },
	{ value: "CHEQUE", label: "Cheque" },
	{ value: "BANK_TRANSFER", label: "Bank Transfer" },
] as const;

export const CHARGES_UNIT_SORT_OPTIONS = [
	{ value: "UNIT", label: "Unit" },
	{ value: "AMOUNT", label: "Amount" },
	{ value: "STATUS", label: "Status" },
] as const;

export const CHARGES_PAYMENT_STATUS_OPTIONS = [
	{ value: "SETTLED", label: "Settled" },
	{ value: "PARTIALLY_PAID", label: "Partially Paid" },
	{ value: "OUTSTANDING", label: "Outstanding" },
	{ value: "PAST_DUE", label: "Past Due" },
] as const;

export const CHARGES_PAYMENT_METHOD_OPTIONS = [
	{ value: "APP", label: "App" },
	{ value: "CASH", label: "Cash" },
	{ value: "CHEQUE", label: "Cheque" },
	{ value: "BANK_TRANSFER", label: "Bank Transfer" },
] as const;
